import type { FC } from 'react';
import { View } from 'react-native';
import { KeyboardStickyView } from 'react-native-keyboard-controller';
import type { FABProps } from 'react-native-paper';
import { FAB } from 'react-native-paper';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const ScrollToEdgeFab: FC<FABProps> = ({ visible, ...rest }) => {
  const { bottom } = useSafeAreaInsets();
  const offset = { closed: -bottom, opened: 0 };

  return (
    visible && (
      <KeyboardStickyView offset={offset}>
        <View
          style={{
            position: 'absolute',
            right: 16,
            bottom: 16,
            zIndex: 1000,
            pointerEvents: 'box-none'
          }}
        >
          <FAB size="small" {...rest} />
        </View>
      </KeyboardStickyView>
    )
  );
};
